export default __webpack_public_path__ + "static/media/icon--sort.853ea259.svg";